<template>
    <div>
        <scale 
        :model_score="monitor_score" 
        :model_comment="monitor_comment" 
        :section="section" 
        :contents="contents"
        :title="title"></scale>
    </div>
</template>
<script>
import db from '@/components/firebase.init';
import Scale from '@/components/Scale';
export default {
    props:['section'],
    data(){
        return{
            monitor_score: [],
            monitor_comment: [],
            na: 0,
            title:"Monitor",
            contents:[
                {
                    question:"Does the monitor have an anti-glare screen installed?",
                    parts: ['Neck']
                },
                {
                    question:"Is the monitor located in front of the user with top of the screen level with user’s eye?",
                    parts: ['Neck']
                },
                {
                    question:"Is the monitor tilted slightly upwards (10-20°, lower if user is wearing bifocal)?",
                    parts: ['Neck']
                },
                {
                    question:"Are the user’s eyes located between rows of overhead lights?",
                    parts: ['Neck']
                },
                {
                    question:`If using two monitors, they are positions for primary and
                            secondary use or for equal use and at the same height and
                            distance. I swivel on my chair (rather than repeatedly twisting my
                            neck) to visually navigate between them`,
                    parts: ['Neck']
                }
            ]
        }
    },
    methods:{
        getTotalScore(){
            let total = 0;
            this.na = 0;
            for(var x = 0; x < this.monitor_score.length; x++){
                if(this.monitor_score[x] == 'NA'){
                    this.na++;
                }
                else{
                    total += this.monitor_score[x]
                }
            }
            
            return total;
        },
        getTotalNa(){
            return this.na;
        },
        invalid(){
            return this.monitor_score.length != this.contents.length || this.monitor_score.includes(undefined);
        },
        submit(id){
            let score = this.getTotalScore();
            db.collection('forms').doc(id).update(
                {
                    monitor_score: this.monitor_score,
                    monitor_comment: this.monitor_comment,
                    monitor_total: score
                }
            ).then(data=>{
                
            })
            .catch(e =>{
                alert(e);
            })
        },
        initializeComment(){
            for(var i = 0; i < this.contents.length; i++){
                this.monitor_comment[i] = "";
            }
        }
    },
    components:{
        'scale' : Scale
    },
    mounted(){
        this.initializeComment();
    }
}
</script>

